import { render, staticRenderFns } from "./SplDialogComponent.vue?vue&type=template&id=135bea53&scoped=true"
import script from "./SplDialogComponent.vue?vue&type=script&lang=js"
export * from "./SplDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135bea53",
  null
  
)

export default component.exports